import { TFunction } from 'i18next';

export const getFilterSubmitLabel = (
  t: TFunction,
  i18nextPrefix?: string
) => {
  const prefix = i18nextPrefix?.trim();

  if (!prefix) {
    return t('button.filter');
  }

  return t(`${prefix}.filters.submit`, {
    defaultValue: t('button.filter'),
  });
};
